/* rc-sticky-cta — show after the hero scrolls past, hide when the enquiry
   section enters view (build-spec §6). Two IntersectionObserver sentinels. Defer. */
(function () {
  if (window.__rcStickyInit) return;
  window.__rcStickyInit = true;

  function init() {
    var bar = document.querySelector('[data-rc-sticky]');
    if (!bar) return;
    /* Move the bar out to <body>: any ancestor with a transform/filter would make position:fixed
       relative to that ancestor, so the bar would float up into the page instead of staying pinned
       to the bottom of the viewport. At body level nothing can break the fixed positioning. */
    if (bar.parentNode !== document.body) document.body.appendChild(bar);
    var hero = document.querySelector('.rc-hero');
    // Hide the bar once this section scrolls into view. Mark a section with
    // data-rc-sticky-stop (RC Process does); fall back to the old enquiry anchor.
    var stop = document.querySelector('[data-rc-sticky-stop]') || document.querySelector('#rc-enquiry');

    var heroVisible = !!hero;     // if no hero, treat as already past
    var stopVisible = false;

    function apply() { bar.classList.toggle('is-visible', !heroVisible && !stopVisible); }

    if (!('IntersectionObserver' in window)) { bar.classList.add('is-visible'); return; }

    if (hero) {
      new IntersectionObserver(function (e) { heroVisible = e[0].isIntersecting; apply(); }, { threshold: 0 }).observe(hero);
    }
    if (stop) {
      // Hide at the stop (RC Process) AND everything below it: true while the stop is
      // in view OR once it has scrolled above the viewport — so the bar does not
      // reappear at related cars / newsletter. (Reappears if you scroll back above it.)
      new IntersectionObserver(function (e) {
        var en = e[0];
        stopVisible = en.isIntersecting || en.boundingClientRect.top < 0;
        apply();
      }, { threshold: 0 }).observe(stop);
    }
    apply();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
